import { motion } from 'motion/react';

import styles from './NorthernLights.module.css';

import bgVideo from '../../assets/video/NorthernLights1.webm';
import bgPoster from '../../assets/images/NorthernLightsPoster1.webp';

export const NorthernLights = () => {
  return (
    <motion.div
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles.bgVideoWrapper}
    >
      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={bgPoster}
      >
        <source src={bgVideo} type="video/webm" />
      </video>
    </motion.div>
  );
};
